// extracted by mini-css-extract-plugin
module.exports = {"content":"TuitionRefundPolicy_content__2M-nw","text":"TuitionRefundPolicy_text__10Vxy"};